module.exports = __webpack_public_path__ + "img/anli-2.72178350.jpg";